import ErrorPage from '../pages/ErrorPage/ErrorPage';
import routesUS from './routes';
import { reducersUS } from './reducers';

export const countryConfigUS = {
    errorPageComponent: ErrorPage,
    routes: routesUS,
    reducers: reducersUS
};
